import { createSelector } from 'reselect';
import { getQueryString } from 'src/react/common/selectors/getQueryString';

export const getSearchParams = createSelector([
    getQueryString,
], (queryString) => new URLSearchParams(queryString));
